import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { simulationRunPath } from "./constants";
import type { SimulationItemResponse, SimulationRunDetail } from "./types";
import { isSimulationRunDetailResult } from "./validators";

export const getSimulationRun = reactQueryFetcherAdapter(
  simulationRunPath,
  (signal: AbortSignal, appGroupId: string, id: string): Promise<SimulationItemResponse<SimulationRunDetail>> =>
    fetch(`/${appGroupId}/conversational/simulation/runs/${id}`, "GET", {}, { signal }),
  isSimulationRunDetailResult
);
